module.exports = __webpack_public_path__ + "static/media/it.e65ea310.png";